const ths = [
  {
    id: 1,
    label: 'Award Unit',
    intlKey: 'table.award_unit',
    sortableId: 'awardUnitRegistration.organization.name'
  },
  {
    id: 2,
    label: 'Registration Date',
    intlKey: 'table.registration_date',
    sortableId: 'awardUnitRegistration.creationDate'
  },
  {
    id: 3,
    label: 'Already running',
    intlKey: 'table.already_running'
  },
  {
    id: 4,
    label: 'Licence Holder',
    intlKey: 'table.licence_holder',
    sortableId: 'awardUnitRegistration.lastName'
  },
  {
    id: 5,
    label: 'Email',
    intlKey: 'table.email',
    sortableId: 'awardUnitRegistration.awardLeaderRegistration.email'
  },
  {
    id: 6,
    label: 'Phone',
    intlKey: 'table.phone',
    sortableId: 'awardUnitRegistration.awardLeaderRegistration.phoneNumber'
  },
  {
    id: 7,
    label: 'Main Award Leader',
    intlKey: 'table.main_award_leader',
    sortableId: 'awardUnitRegistration.awardLeaderRegistration.lastName'
  },
  {
    id: 8,
    label: 'Action',
    intlKey: 'table.action'
  }
]

export default ths
